import { useDelete } from '@refinedev/core';
import { DetectionEntity } from '../types';
import { EntityWithFieldMetadata } from '../../UI/dynamicUI/types';

export function useDeleteEntities() {
  const { mutateAsync, isError, isLoading, reset } = useDelete();

  const deleteEntities = async (
    entities: DetectionEntity[],
    clientId: string,
  ) => {
    const deleteRequests = entities.map((entity) => {
      const entityId = entity.fields.id?.toString();
      if (!entityId) {
        return;
      }
      return mutateAsync({
        resource: `clients/${clientId}/entity-types/${entity.entityType}/entities`,
        id: entityId,
      });
    });
    await Promise.all(deleteRequests);
  };

  const deleteEntityByTypeAndId = async (
    clientId: string,
    entityType: string,
    entityId: string
  ) => {
    if (!entityId) {
      return;
    }
    return mutateAsync({
      resource: `clients/${clientId}/entity-types/${entityType}/entities`,
      id: entityId,
    });
  };

  const deleteEntity = async (
    entity: EntityWithFieldMetadata,
    clientId: string,
  ) => {
    const entityId = entity.fields.id?.toString();
    if (!entityId) {
      return;
    }
    return deleteEntityByTypeAndId(
      clientId,
      entity.entityType,
      entityId,
    )
  };

  return {
    deleteEntities,
    deleteEntity,
    deleteEntityByTypeAndId,
    isError,
    isLoading,
    reset,
  };
}
